"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCatalogDateDataset = exports.isCatalogFact = exports.isCatalogMeasure = exports.isCatalogAttribute = exports.catalogItemMetadataObject = void 0;
// (C) 2019-2020 GoodData Corporation
var attribute_1 = require("./attribute");
var measure_1 = require("./measure");
var fact_1 = require("./fact");
/**
 * Get metadata object that catalog item represents
 *
 * @param catalogItem - catalog item
 * @returns metadata object
 * @public
 */
exports.catalogItemMetadataObject = function (catalogItem) {
    var item;
    if (attribute_1.isCatalogAttribute(catalogItem)) {
        item = catalogItem.attribute;
    }
    else if (measure_1.isCatalogMeasure(catalogItem)) {
        item = catalogItem.measure;
    }
    else if (fact_1.isCatalogFact(catalogItem)) {
        item = catalogItem.fact;
    }
    else {
        item = catalogItem.dataSet;
    }
    if (!item) {
        throw new Error("Catalog metadata item not found!");
    }
    return item;
};
var attribute_2 = require("./attribute");
Object.defineProperty(exports, "isCatalogAttribute", { enumerable: true, get: function () { return attribute_2.isCatalogAttribute; } });
var measure_2 = require("./measure");
Object.defineProperty(exports, "isCatalogMeasure", { enumerable: true, get: function () { return measure_2.isCatalogMeasure; } });
var fact_2 = require("./fact");
Object.defineProperty(exports, "isCatalogFact", { enumerable: true, get: function () { return fact_2.isCatalogFact; } });
var dateDataset_1 = require("./dateDataset");
Object.defineProperty(exports, "isCatalogDateDataset", { enumerable: true, get: function () { return dateDataset_1.isCatalogDateDataset; } });
//# sourceMappingURL=index.js.map